export const columns = [
  {
    title: 'page_tenant_operation',
    key: 'action',
    width: 90,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: '查看',
    key: 'read',
    width: 90,
    scopedSlots: { customRender: 'read' }
  },
  {
    title: '启用',
    key: 'status',
    width: 90,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: "分类",
    dataIndex: "category",
    key: "category",
    ellipsis: true,
    scopedSlots: { customRender: 'category' }
  },
  {
    title: "资源编号",
    dataIndex: "ossCode",
    key: "ossCode",
    ellipsis: true,
  },
  {
    title: "资源地址",
    dataIndex: "endpoint",
    key: "endpoint",
    ellipsis: true,
  },
  {
    title: "空间名",
    dataIndex: "bucketName",
    key: "bucketName",
    ellipsis: true,
  },
  {
    title: "accessKey",
    dataIndex: "accessKey",
    key: "accessKey",
    ellipsis: true,
  },
  {
    title: "secretKey",
    dataIndex: "secretKey",
    key: "secretKey",
    ellipsis: true,
  },
  {
    title: "是否启用",
    dataIndex: "statusName",
    key: "statusName",
    ellipsis: true,
  },
]
